import { FC } from 'react';
import type { UserProject } from '@teachur/http-client';
import { CourseDetailsSidePanel } from './CourseDetailsSidePanel';
import { FilePreviewSidePanel } from './FilePreviewSidePanel';
import { SubmissionsHistorySidePanel } from './SubmissionsHistorySidePanel';
import { getLatestSubmission } from '../../utils/projectReviewDrawerHelpers';

interface ProjectDrawerSidePanelProps {
  project: UserProject | null;
  isSubmissionsHistoryOpen: boolean;
  isFilePreviewOpen: boolean;
  courseId?: number;
  onCloseSubmissionsHistory: () => void;
  onCloseFilePreview: () => void;
  onCloseCourseDetails: () => void;
}

export const ProjectDrawerSidePanel: FC<ProjectDrawerSidePanelProps> = ({
  project,
  isSubmissionsHistoryOpen,
  isFilePreviewOpen,
  courseId,
  onCloseSubmissionsHistory,
  onCloseFilePreview,
  onCloseCourseDetails,
}) => {
  const latestSubmission = getLatestSubmission(project);

  if (isSubmissionsHistoryOpen) {
    return <SubmissionsHistorySidePanel project={project} onClose={onCloseSubmissionsHistory} />;
  }

  if (isFilePreviewOpen && latestSubmission?.file) {
    return <FilePreviewSidePanel file={latestSubmission.file} onClose={onCloseFilePreview} />;
  }

  if (courseId) {
    return <CourseDetailsSidePanel courseId={courseId} onClose={onCloseCourseDetails} />;
  }

  return null;
};
